import React from 'react';
import CrudPage from '../components/CrudPage';

export const HSE = () => (
  <CrudPage overline="Health · Safety · Environment" title="HSE Incident Report"
    subtitle="Near misses, first-aid, LTI and reportable incidents across all sites."
    endpoint="incidents"
    formId="hse_incident"
    fields={[
      { key: 'incident_date', cfg: 'incident_date', label: 'Incident Date', type: 'date', required: true },
      { key: 'type', cfg: 'type', label: 'Incident Type', type: 'select', options: ['Near Miss','First Aid','Medical Treatment','LTI','Fatality','Property Damage','Environmental'], required: true },
      { key: 'severity', cfg: 'severity', label: 'Severity', type: 'select', options: ['Low','Medium','High','Critical'], required: true },
      { key: 'location', cfg: 'location', label: 'Location' },
      { key: 'description', cfg: 'description', label: 'Description', type: 'textarea', full: true, required: true },
      { key: 'persons_involved', cfg: 'persons_involved', label: 'Persons Involved', type: 'textarea', full: true },
      { key: 'immediate_action', cfg: 'immediate_action', label: 'Immediate Action Taken', type: 'textarea', full: true },
    ]}
    columns={[
      { key: 'incident_date', label: 'Date', type: 'date' }, { key: 'location', label: 'Location' },
      { key: 'type', label: 'Type', type: 'status' }, { key: 'severity', label: 'Severity', type: 'status' },
      { key: 'description', label: 'Description' },
    ]}
  />
);

export const Documents = () => (
  <CrudPage overline="Document Management" title="Document Repository"
    subtitle="Searchable, version-controlled repository of all project documents."
    endpoint="documents"
    fields={[
      { key: 'doc_no', label: 'Document No' },
      { key: 'title', label: 'Title', full: true },
      { key: 'category', label: 'Category', type: 'select', options: ['Drawings','Contracts','POs','Invoices','Reports','ITP','Correspondence'] },
      { key: 'project', label: 'Project' },
    ]}
    columns={[
      { key: 'doc_no', label: 'No' }, { key: 'title', label: 'Title' },
      { key: 'category', label: 'Category' }, { key: 'project', label: 'Project' },
    ]}
  />
);
